import React from 'react'
import "../../styles/componentsStyles/Explore/FeedCard.scss"
import { Link } from 'react-router-dom'

const FeedCard = ({ feedDetails }) => {
    console.log(feedDetails)
    return (
        <>
            {
                feedDetails.map(feedData => <Link to="/browse" className='feed-card' key={feedData.channelId}>
                    <img className="feed-card__thumbnail" src={feedData.thumbnail} alt="thumbnail" />
                    <div className="feed-card__content-info">
                        <div>
                            <h4 className='feed-card__title'>
                                {feedData.title.substring(0, 80)}
                                {
                                    (feedData.title.length > 80) ? <span>...</span> : ""
                                }
                            </h4>
                            <p className='feed-card__stats'>
                                <span>{feedData.views} views &#183; {feedData.likes} likes </span>
                            </p>
                        </div>
                        <div className="feed-card__channel-info">
                            <img src={feedData.channelLogo} alt="logo" />
                            <span>{feedData.channelName}</span>
                        </div>
                    </div>
                </Link>)
            }
        </>
    )
}

export default FeedCard